import React from 'react'
import { Navbar, Nav, Image } from 'react-bootstrap'
import PhoneIcon from '@material-ui/icons/Phone';
import GitHubIcon from '@material-ui/icons/GitHub';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import TwitterIcon from '@material-ui/icons/Twitter';
import { Insta } from './Insta.js'
import StackOverflow from './StackOverflow.svg'
import Gmail from './gmail.svg'
import Linked from './linkedin.svg'

export const HeaderMobile = () => {
    return (
        <Navbar style={{ fontSize:10, overflowX:"scroll !important", borderBottom:"0.2px solid rgb(52,52,52)" }} fixed='top'>
            <Nav.Link href="mailto:adityaubale63@gmail.com" className='mx-auto' id="icon">
                <Image src={Gmail} style={{ width:"1.5rem" }} />
            </Nav.Link>
            <Nav.Link href="tel:8770471714" className='mx-auto' id="icon">
                <PhoneIcon style={{ fontSize:"1.5rem", color:'rgb(66, 135, 245)' }}/>
            </Nav.Link>
            <Nav.Link href="https://github.com/aditya25022001" target="_blank" rel="noopener noreferrer" className='mx-auto' id="icon">
                <GitHubIcon style={{ fontSize:"1.5rem", color:"white" }}/>
            </Nav.Link>
            <Nav.Link href="https://www.linkedin.com/in/aditya-uday-ubale-14833b175/" target="_blank" rel="noopener noreferrer" className='mx-auto' id="icon">
                <Image src={Linked} />
            </Nav.Link>
            <Nav.Link href="whatsapp://send?phone=918770471714" className='mx-auto' id="icon">
                <WhatsAppIcon style={{ fontSize:"1.5rem", color:"rgb(0,230,118)" }}/>
            </Nav.Link>
            {typeof window ==="object" && window.innerWidth>500 && 
                <>
                    <Nav.Link href="https://stackoverflow.com/users/11622254/aditya-uday-ubale" target="_blank" rel="noopener noreferrer"className='mx-auto' id="icon">
                        {typeof window==="object" && window.innerWidth>500 ? <Image src={StackOverflow} style={{ width:"1.2rem" }} /> : <Image src={StackOverflow} style={{ width:"1rem" }} />}
                    </Nav.Link>
                    <Nav.Link href="https://www.instagram.com/adityaudayubale/" target="_blank" rel="noopener noreferrer"className='mx-auto' id="icon">
                        <Insta />
                    </Nav.Link>
                    <Nav.Link href="https://twitter.com/adityaudayubale" target="_blank" rel="noopener noreferrer"className='mx-auto' id="icon">
                        <TwitterIcon style={{ fontSize:"1.5rem", color:"rgb(29,161,242)" }}/>
                    </Nav.Link>
                </>
            }
        </Navbar>
    )
}
